import api from '../../../services/api';
import { normalizeTransportRoutes, TransportRouteSummaryDto } from '../../../dto/transport';

export async function listTransportRoutesForSelection(): Promise<TransportRouteSummaryDto[]> {
  const response = await api.get('/transport-routes');
  return normalizeTransportRoutes(response.data, 'transportRoutes.selection');
}

export async function createSplitTransportRoutes(payload: Record<string, unknown>): Promise<any> {
  const response = await api.post('/transport-routes/split', payload);
  return response.data;
}

/**
 * Delete a transport (shared or single-order). Transports live under
 * /transport-routes regardless of how many orders they carry, so the deletion
 * seam belongs here rather than under any order-scoped API module.
 */
export async function deleteTransportRoute(transportId: string): Promise<void> {
  await api.delete(`/transport-routes/${transportId}`);
}
